import { DomainObjects } from 'projectlink-common'

const domainColor = (domain: DomainObjects) => {
  switch (domain) {
    case DomainObjects.organization: {
      return 'cyan.dark'
    }
    case DomainObjects.project: {
      return 'highlight.pink'
    }
    case DomainObjects.reference: {
      return 'highlight.purple'
    }
    default: return 'primary.accent3'
  }
}

export {
  domainColor,
}